import _take from "ramda/es/take";
import _drop from "ramda/es/drop";
import _curry from "ramda/es/curry";
export default _curry(function (n, s) {
  return "".concat(_drop(n, s)).concat(_take(n, s));
});